import { FC, CSSProperties } from 'react';
import { Box, Divider, Theme, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

export interface WbDividerProps {
  orientation?: 'vertical' | 'horizontal';
  height?: string;
  className?: string;
  style?: CSSProperties;
}

const useStyles = makeStyles((theme: Theme) => ({
  vertical: {
    background: theme.palette.grey[200],
    width: '1px',
    height: '24px',
  },
}));

export const WbDivider: FC<WbDividerProps> = ({
  orientation = 'vertical',
  height,
  className,
  style,
}) => {
  const classes = useStyles();
  return orientation === 'vertical' ? (
    <Box
      className={clsx(classes.vertical, className)}
      style={{
        height: height ?? '24px',
        ...style,
      }}
    />
  ) : (
    <Divider className={className} style={style} />
  );
};
